module.exports = __webpack_public_path__ + "img/exclamation-triangle.2e840950.svg";